<template>
    <div>
  
      <div class="card">
        <div class="card card-custom" >
          <div class="card-header flex-wrap border-0 pt-6 pb-0">
            <div class="card-title">
              <h3 class="card-label">{{ $t('setting.reason_list') }}</h3>
            </div>
            <div class="card-toolbar" >
              <Button btn-class="btn-sm" type="new" btn-text="setting.new_reason" @click="openCreateModal"/>
            </div>
          </div>
  
          <div class="card-body" >
            <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_reason" style="margin-top: 13px !important; cursor:pointer">
              <thead>
              <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                <th> {{$t("setting.reason")}}</th>
                <th> {{$t("setting.type")}}</th>
                <th>{{$t("actions")}}</th>
              </tr>
              </thead>
            </table>
          </div>

        </div>

      </div>

      <Create
          id="kt_modal_create_reason"
          @afterCreate="reloadDatatable"
      />

      <Update
          id="kt_modal_update_reason"
          :reason="reason"
          @afterCreate="reloadDatatable"
      />

    </div>
  </template>

  <script setup>
  import Create from '@/Modules/Financial/components/Modals/Reason/CreateReasonModal.vue';
  import Update from '@/Modules/Financial/components/Modals/Reason/UpdateReasonModal.vue';
  import {BASE_URL} from "@/services/api";
  import { useRouter } from "vue-router"
  import Ls from "@/services/ls";
  import { useI18n } from 'vue-i18n'
  import {useStore} from "vuex";
  import {nextTick, onMounted, ref, watch} from "vue"
  import {useHasAbility} from "@/composables/hasAbility";
  import { useLocales } from '@/composables/locales';
  import Button from "@/components/Button.vue"
  import {useSwal} from "@/composables/useSwal";
  import abilities from "@/composables/abilities";
  import {Theme} from "@/composables/theming";

  const {showSwal} = useSwal()
  const { t } = useI18n({ useScope: 'global' })
  const { can } = useHasAbility()

  const table = ref(null)

  const {locale, datatableLocaleUrl} = useLocales()

  const reason = ref({
    id:"",
    name:"",
    type:[]
  })

  const router = useRouter()

  const store = useStore()

  onMounted(() => {
    reloadDatatable()
    store.dispatch("reason/loadReasonTypes")
  })

  watch(() => locale.value, () => {
    nextTick(() =>  fetchPayment('kt_datatable_reason') )
  })

  function openCreateModal(){
    $('#kt_modal_create_reason').modal('toggle')
  }

  $(document).on("click", "#kt_datatable_reason .delete_btn", (e) => {
    deletePost(e.target.getAttribute('data-id'))
  });

  function fetchPayment(tableId){
    const AUTH_TOKEN = Ls.get('auth.token')
    const pageLimit = Ls.get('pageLength')
    table.value = $("#" + tableId).DataTable({
      destroy: true,
      responsive: !0,
      searchDelay: 500,
      processing: !0,
      serverSide: !0,
      pageLength: pageLimit ||  5,
      lengthMenu: [5, 10, 25, 50, 75, 100 ],
      order: [[ 0, 'asc']],
      ajax: {
        url: BASE_URL + "/reason/datatables",
        type: "GET",
        beforeSend: function (request, options) {
          request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          request.setRequestHeader("Company", Ls.get('current.company'));
        }
      },
      columns: [{ data: "name" },{  data: "types",  }, { data: "Actions", responsivePriority: -1 }],
      columnDefs: [

        {
          targets: -3,
          order: "desc",
          render: function (t, a, e, l) {
            return '<span>' + t + "</span>";
          },
        },
        {
          targets: -2,
          order: "desc",
          render: function (t, a, e, l) {
            let result = ""
            e.types.forEach(el => {
              result += `<span class="badge badge-${el.color} me-3"> ${ el[locale.value] } </span>`
            })
            return result;
          },
        },
        {
          width: "15%",
          targets: -1,
          "className": "dt-center",
          title: "Actions",
          orderable: !1,
          render: (t, a, e, l) => {
            let render=""

              render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" data-type="'+ e.used_for +'" class="btn btn-sm btn-clean btn-icon edit_btn" ><i data-row="'+ l.row +'" data-id="'+ e.id +'" data-name="'+ e.name +'" data-type="'+ e.used_for +'"  class="fas fa-edit fs-2" data-toggle="tooltip" data-placement="top" title="'+i18n.global.t('button.edit')+'" style="color: '+Theme.gray +'"></i></a>'

              render += '<a href="javascript:;"  data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn"><i  data-id="'+ e.id +'" class="fas fa-trash fs-2"  data-toggle="tooltip" data-placement="top" title="'+i18n.global.t('button.delete')+'" style="color: '+Theme.gray +'"></i></a>'

            return render
          },
        },
      ],
      language: {
        url:  datatableLocaleUrl.value
      }
    });

  }

  $(document).on("click", "#kt_datatable_reason .edit_btn", (e) => {
    reason.value.id = e.target.getAttribute('data-id')
    reason.value.name = e.target.getAttribute('data-name')
    reason.value.type = e.target.getAttribute('data-type').split(",")
    $('#kt_modal_update_reason').modal('toggle')

  });



  function reloadDatatable() {
    fetchPayment('kt_datatable_reason')
  }
  
  async function deletePost(id){
    showSwal(
        '',
        i18n.global.t('swal.post_deleting')
    ).then( async (result) => {
        if (result.value) {
          try {
            await store.dispatch('post/deletePost', id)
            reloadDatatable()
            window.toastr.success(t('notification.post_deleted'))
          }catch (e) {
          }
        }
    })
  }
  
  </script>
  